

import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { psegLoadsTbl } from '../Models/LoadsData';
import { PsegDemandService } from './pseg-demand.service';

@Injectable({
  providedIn: 'root'
})
export class PsegDemandResolverService implements Resolve<Array<psegLoadsTbl>> {
  PsegloadsData: Observable<Array<psegLoadsTbl>>;
  constructor(private psegLoadDemandSvc: PsegDemandService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Array<psegLoadsTbl>> | Promise<Array<psegLoadsTbl>> | Array<psegLoadsTbl> {
    this.PsegloadsData= this.psegLoadDemandSvc.GetPsegLoadDemand();
    return this.PsegloadsData;
  }
}